import { DATA, KEY, NUMBER, OPTIONAL_KEY, Resource } from "shelving";

export const START_CHALLENGE = new Resource("startChallenge", KEY);
export const PROGRESS_TASK = new Resource("progressTask", DATA({ cid: KEY, tid: KEY, amount: NUMBER, units: OPTIONAL_KEY }));
export const CLAIM_CHALLENGE = new Resource("claimChallenge", KEY);
export const RESET_CHALLENGE = new Resource("resetChallenge", KEY);
